import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/commons/generic.service';
import { Endereco } from 'src/app/model/endereco';

@Injectable({
  providedIn: 'root'
})
export class ConsultaCepService extends GenericService {

  private relativePath = 'api/consulta-cep';
  resultadoChamado: Observable<string>;

  constructor(http: HttpClient) {
      super(http);
  }

  obterEndereco(cep:number): Observable<Endereco> {
    console.log(this.url + this.relativePath + '/'+ cep);
    return this.http.get<Endereco>(this.url + this.relativePath + '/'+ cep);
}
}


